import React from 'react';
import { textStyle } from '../config/theme';

const TICKER_MESSAGE =
  'Welcome!  We are not live yet, but drop us a line on x.com @taknixyz if you need anything';

function TickerSegment() {
  return (
    <>
      {TICKER_MESSAGE}
      <span className="global-ticker-banner__sep" aria-hidden="true">
        {' '}
        •{' '}
      </span>
    </>
  );
}

const GlobalTickerBanner: React.FC = () => (
  <div className="global-ticker-banner" role="status" aria-label={TICKER_MESSAGE}>
    <div className="global-ticker-banner__track">
      <span className="global-ticker-banner__content" style={textStyle('sm')}>
        <TickerSegment />
        <TickerSegment />
        <TickerSegment />
      </span>
      <span className="global-ticker-banner__content" style={textStyle('sm')} aria-hidden="true">
        <TickerSegment />
        <TickerSegment />
        <TickerSegment />
      </span>
    </div>
  </div>
);

export default GlobalTickerBanner;
